export default {
  'imm5562.steps.sectionA': '主申請人（您自己）',
  'imm5562.steps.sectionB': '您的配偶或同居伴侶',
  'imm5562.steps.sectionC': '您18歲或以上的受扶養子女',

  'imm5562.title.principalApplicant': 'A部分：主申請人（您自己）',
  'imm5562.description.principalApplicant':
    '列出您在過去10年中（或如果您未滿18歲，則自18歲生日以來）在原籍國或居住國以外的所有旅行。包括所有旅行：旅遊、商務、培訓等。如果您在此期間未出國旅行，請勾選“未旅行”。',

  'imm5562.title.partnerApplicant': 'B部分：您的配偶或同居伴侶',
  'imm5562.description.partnerApplicant':
    '列出您的配偶或同居伴侶在過去10年中（或如果他們未滿18歲，則自18歲生日以來）在原籍國或居住國以外的所有旅行。包括所有旅行：旅遊、商務、培訓等。如果他們在此期間未出國旅行，請勾選“未旅行”。',

  'imm5562.title.dependantApplicant': 'C部分：您18歲或以上的受扶養子女',
  'imm5562.description.dependantApplicant':
    '列出您18歲或以上的受扶養子女在過去10年中（或如果他們未滿18歲，則自18歲生日以來）在原籍國或居住國以外的所有旅行。包括所有旅行：旅遊、商務、培訓等。如果他們在此期間未出國旅行，請勾選“未旅行”。',

  'imm5562.title.formList.trips': '旅行 #',

  'imm5562.fields.haveNotTravelled': '未旅行',
  'imm5562.fields.fullName': '全名',
  'imm5562.fields.from': '從（YYYY/MM）',
  'imm5562.fields.to': '到（YYYY/MM）',
  'imm5562.fields.destination': '目的地（城市，國家）',
  'imm5562.fields.length': '時長（例如：6天）',
  'imm5562.fields.purposeOfTravel': '旅行目的（例如：商務）',
};
